module.exports = __webpack_public_path__ + "static/img/3.2913597e.jpg";